import DrawBase from '../components/base/draw-base';
import React from 'react';

const TourneysComponentsFormRulesPartDraw = () => {
  return <DrawBase sportType="general" />;
};

export default TourneysComponentsFormRulesPartDraw;
